<template>
  <div class="content flex flex-col justify-center items-center gap-5 w-full bg-white rounded-md shadow-ts1 mb-24 min-h-[100vh] md:min-h-[80vh]">
    <img style="width: 150px" class="pt-4 md:pt-2" src="../../../assets/img/crypto-deposit-successful.svg" />
    <h1 class="text-3xl text-center font-semibold font-display">{{ $t('thank_you').tTitle() }}</h1>
    <p class="text-center text-body font-display">{{ $t('your_deposit_successful') }}</p>
    <router-link
      :to="'/' + Language + '/'"
      class="py-3 h-full bg-blue rounded-md text-white appearance-none font-bold text-base text-center w-40 ltr:float-right rtl:float-left cursor-pointer"
    >
      {{ $t('go_to_dashboard') }}
    </router-link>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      Language: 'language/code',
    }),
  },
}
</script>
